// Auto-detect bare URLs in plain text and convert them to Markdown links so
// ReactMarkdown will render them clickable. Skips URLs already inside a Markdown
// link (e.g. [label](https://…)) to avoid double-wrapping, and skips fenced code
// blocks so URLs in code samples stay literal. (Extracted from PublicSilo so the
// Workbench AI Assistant can reuse the exact same clickable-link behavior.)
export function linkifyUrls(text) {
  if (!text) return text;
  const codeBlocks = [];
  let i = 0;
  const stashed = text.replace(/```[\s\S]*?```/g, (m) => {
    codeBlocks.push(m);
    return `\u0000CODEBLOCK_${i++}\u0000`;
  });
  const mdLinks = [];
  let j = 0;
  const stashed2 = stashed.replace(/!?\[[^\]]*\]\([^)]*\)/g, (m) => {
    mdLinks.push(m);
    return `\u0000MDLINK_${j++}\u0000`;
  });
  const URL_RE = /\b((?:https?:\/\/|www\.)[^\s<>()[\]'"`*]+[^\s<>()[\]'"`*.,!?;:])/g;
  const linkified = stashed2.replace(URL_RE, (raw) => {
    const href = raw.startsWith("www.") ? `https://${raw}` : raw;
    return `[${raw}](${href})`;
  });
  let out = linkified;
  out = out.replace(/\u0000MDLINK_(\d+)\u0000/g, (_m, idx) => mdLinks[Number(idx)]);
  out = out.replace(/\u0000CODEBLOCK_(\d+)\u0000/g, (_m, idx) => codeBlocks[Number(idx)]);
  return out;
}
